import { FC } from 'react';
import { Text, Title } from 'components/Typography';

interface ErrorFallbackProps {
  error: Error;
}

export const ErrorFallback: FC<ErrorFallbackProps> = ({ error }) => {
  return (
    <div style={{ padding: '2rem' }}>
      <Title level={3}>Something went wrong</Title>
      {error.message && <Text type="danger">{error.message}</Text>}
    </div>
  );
};
